import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core'
import { SharedDataService } from 'src/app/core/services/shared-data.service'

@Component({
    selector: 'app-autopay-popup',
    templateUrl: './autopay-popup.component.html',
    styleUrls: ['./autopay-popup.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AutopayPopupComponent implements OnInit {
  constructor(   public sharedDataService: SharedDataService) {}
  @Input() type: number = 1
  @Input() additionalClasses = ''
  @Input() isMobile = false
  @Input() promoMonth = 12
  @Input() showData
  @Input() maxLoanAmount
  @Input() approvedAmount
  @Output() closed: EventEmitter<unknown> = new EventEmitter()
  @Output() loadForm: EventEmitter<unknown> = new EventEmitter()
  @Output() update: EventEmitter<unknown> = new EventEmitter()

  popupVisibility = 'inherit'

  close() {
    this.closed.emit(true)
  }
  load(){
    this.loadForm.emit(true)
  }
  dataUpdate(){
    this.update.emit(true)
  }

  ngOnInit(): void {
  }

}
